import { 
    GET_UNSERVICEABLE_AREA_REQUEST,
    GET_ALL_UNSERVICEABLE_AREA_REQUESTS,
    GET_UNSERVICEABLE_AREA_REQUEST_REQUEST,
    DELETE_UNSERVICEABLE_AREA_REQUEST,
    CLEAR_UNSERVICEABLE_AREA_REQUEST
} from '../actions/types';

const initialState = {
    unserviceableAreaRequests: [],
    unserviceableAreaRequest: null,
    pagination: {
        page: 1,
        limit: 10,
        total: 0,
        pages: 0
    },
    loading: true
}

export default (state = initialState, { type, payload }) => {
    switch (type) {

    case GET_ALL_UNSERVICEABLE_AREA_REQUESTS:
        return { 
            ...state, 
            unserviceableAreaRequests: payload.unserviceableAreaRequests,
            pagination: {
                page: payload.page,
                limit: payload.limit,
                total: payload.total,
                pages: payload.pages
            },
            loading: false 
        };

    case GET_UNSERVICEABLE_AREA_REQUEST:
        return { 
            ...state, 
            unserviceableAreaRequest: payload.unserviceableAreaRequest,
            loading: false 
        };

    case GET_UNSERVICEABLE_AREA_REQUEST_REQUEST:
        return { 
            ...state, 
            loading: payload 
        };

    case DELETE_UNSERVICEABLE_AREA_REQUEST:
        return {
            ...state,
            unserviceableAreaRequests: state.unserviceableAreaRequests.filter(request => request._id !== payload),
            loading: false
        };

    case CLEAR_UNSERVICEABLE_AREA_REQUEST:
        return {
            ...state,
            unserviceableAreaRequest: null,
            loading: false
        };

    default:
        return state
    }
}
